import ReactDirective from "acl-ui/angular/reactDirective.umd";
import HamburgerMenu from "@viz-ui/components/hamburgerMenu/hamburgerMenu";
import ChartBaseContainer from "@viz-ui/components/charts/ChartBaseContainer";
import slidingNavTabs from "./slidingNavTabs.directive";

angular
  .module("acl.visualizer.slidingNavTabs", [
    "acl.common.event",
    "acl.common.localize",
    "acl.visualizer.dataFilter",
    "acl.visualizer.dataModel",
    "acl.visualizer.model.field",
    "acl.visualizer.model.tableConfig",
    "acl.visualizer.processPanel",
    "acl.visualizer.tabState",
  ])
  .directive("aclSlidingNavTabs", slidingNavTabs)
  .directive("hamburgerMenu", ReactDirective.getFactory(HamburgerMenu))
  .directive("chartBaseContainer", ReactDirective.getFactory(ChartBaseContainer));
